import { render, staticRenderFns } from "./CustomizeLoginErp.vue?vue&type=template&id=5de3aea6"
import script from "./CustomizeLoginErp.vue?vue&type=script&lang=js"
export * from "./CustomizeLoginErp.vue?vue&type=script&lang=js"
import style0 from "./CustomizeLoginErp.vue?vue&type=style&index=0&id=5de3aea6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports